var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.26 12.4219C22.799 12.4766 20.5021 11.7109 18.5334 10.2891V20.0781C18.5334 23.7969 16.2365 27.0781 12.7365 28.3906C9.29121 29.7031 5.35371 28.7188 2.94746 25.9297C0.486525 23.0859 0.0490248 19.0938 1.79902 15.8125C3.54902 12.5859 7.1584 10.7812 10.8771 11.2734V16.1953C9.18184 15.6484 7.32246 16.25 6.2834 17.6719C5.29903 19.1484 5.29903 21.0625 6.33809 22.4844C7.37715 23.9062 9.23652 24.5078 10.8771 23.9609C12.5725 23.4141 13.7209 21.8281 13.7209 20.0781V0.9375H18.5334C18.5334 1.375 18.5334 1.75781 18.6428 2.19531C18.9709 4 20.01 5.58594 21.5959 6.57031C22.635 7.28125 23.9475 7.66406 25.26 7.66406V12.4219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c576d4ec40700c6cbe5e3195c1ec56bf.svg";
export { ForwardRef as ReactComponent };